'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _readmoreJs = require('readmore-js');

var _readmoreJs2 = _interopRequireDefault(_readmoreJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReadMore = function ReadMore(el) {
  (0, _classCallCheck3.default)(this, ReadMore);

  (0, _jquery2.default)('.prd-PanelsItem_Desc').readmore({
    speed: 75,
    collapsedHeight: 180,
    moreLink: '<div class="prd-PanelsItem_LinkWrap"><a href="#" class="prd-PanelsItem_Link cta-Dark">Read more</a></div>',
    lessLink: '<div class="prd-PanelsItem_LinkWrap"><a href="#" class="prd-PanelsItem_Link cta-Dark">Read less</a></div>'
  });
};

exports.default = ReadMore;